export const ACTIVATE_DMX_DEVICE_PRESET = 'ACTIVATE_DMX_DEVICE_PRESET';
export const ACTIVATE_DMX_DEVICE_PRESET_SUCCESSFUL = 'ACTIVATE_DMX_DEVICE_PRESET_SUCCESSFUL';
export const ACTIVATE_DMX_DEVICE_PRESET_FAILED = 'ACTIVATE_DMX_DEVICE_PRESET_FAILED';
